import { render, staticRenderFns } from "./MyResourceRequest.vue?vue&type=template&id=3e61e276"
import script from "./MyResourceRequest.vue?vue&type=script&lang=js"
export * from "./MyResourceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports